import { render, staticRenderFns } from "./predictSerList.vue?vue&type=template&id=1555b210&scoped=true&"
import script from "./predictSerList.vue?vue&type=script&lang=js&"
export * from "./predictSerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1555b210",
  null
  
)

export default component.exports